import React, { memo, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Card from '../components/Card';
import SpeakerDoc from './SpeakerDoc';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyImage from '../../CustomLibraries/LazyImage';
import parse from 'html-react-parser';
import { parseJson, reactHtmlParser, specialityPopOver } from '../../../common/common';
import { default_images } from '../../../common/defaultImages';
import { clinical_Video_static_image, medwiki_static_image } from '../../../common/assets.common';
import dayjs from 'dayjs';
import useRedirect from '../../customHooks/useRedirect';
import ReportContentPopover from './components/ReportContentPopover';
import useShare from '../../customHooks/useShare';
import CpdPoint from '../../cards/session/sessionCardV1/components/CpdPoint';
import GetRecordingModal from '../../modals/uiv3/GetRecordingModal';
// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
const FeaturedCard = ({
  type = '',
  navType = '',
  sponsorLogo,
  id,
  title,
  specialities,
  deeplink,
  moduleType,
  question,
  image,
  likeCount,
  commentCount,
  viewCount,
  sessionDoctorEntities,
  startDateTime,
  endDateTime,
  participantCount,
  onClick,
  specialities_ids_and_names,
  cpdDetails,
  click
}) => {
  const sponserLogo = sponsorLogo ? sponsorLogo.split(',') : [];
  const sessionDoctorDetails = sessionDoctorEntities ?? [];
  const onCardClick = (id, title) => {
    if (onClick) {
      onClick(id, title);
    }
  };

  const { redirectTo } = useRedirect();
  const share_url = useShare();

  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { master_specialities_id, specialities_name } = specialities_ids_and_names[0];
      redirectTo('Speciality', master_specialities_id, specialities_name);
    }
  };
  const cardClick = () => (click ? click() : redirectTo('SessionDetails', id));
  const [show, setShow] = useState(false);
  const modalClose = useCallback(
    (data) => {
      setShow(data);
    },
    [show]
  );

  console.group('cmecard', navType);
  console.log('image ', image);
  console.groupEnd('cmecard', navType);
  return (
    <Card
      className={`clr_v3_card__featured ${
        navType == 'Watch' ? 'clr_v3_card__clinicalVideos loadPlayer' : ''
      }`}
      type={type}
    >
      <span className="clr_v3_card__featured__tag bg-primary rounded-pill position-absolute text-white">
        <i className="clr_v3_card__featured__icon translate-middle start-50 top-50 position-absolute">
          <i className="flaticon-danger fs-1"></i>
        </i>
      </span>
      <Card.Body>
        <Card.Header className="">
          {/* {specialities && (
            <span
              className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer"
              onClick={specialityClick}
            >
              <span>{specialities?.split(',')[0]}</span>
              {specialityPopOver(specialities)}
            </span>
          )} */}

          <div className="ms-auto align-items-center d-flex gap-sm-3 gap-2">
            {deeplink && question ? (
              <span
                className="icon-size-32 icon-size-sm-36 clr_v3_card__icon transition cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2 clr_v3_icon-btn-1"
                onClick={() => {
                  share_url(question, deeplink);
                }}
              >
                <i className="flaticon-share"></i>
              </span>
            ) : (
              <></>
            )}

            {/* <i className="flaticon-more-1 fs-1"></i> */}
            <ReportContentPopover type={moduleType} id={id} />
          </div>
        </Card.Header>
        <div className="d-flex cursorPointer" onClick={() => onCardClick(id, title)}>
          {type == 'small' && image && (
            <div className="d-flex align-items-start me-md-4 me-3">
              <Card.Image className="mt-3" onClick={() => onCardClick(id, title)}>
                <LazyImage
                  src={image}
                  alt="banner"
                  fallback_image={medwiki_static_image}
                  className={`object-fit-cover w-100 h-100`}
                  extraClass="hover-image w-100 h-100 position-relative"
                />
              </Card.Image>
            </div>
          )}
          <div
            className="flex-grow-1 d-flex justify-content-center flex-column"
            onClick={() => onCardClick(id, title)}
          >
            {title && <Card.Title className="hover-opacity">{reactHtmlParser(title)}</Card.Title>}
          </div>
        </div>
        {navType == 'watch' && sessionDoctorDetails && <SpeakerDoc data={sessionDoctorDetails} />}
        {type !== 'small' && navType == 'read' && image && (
          <Card.Image className="mt-3 cursorPointer">
            <LazyImage
              src={image}
              alt="banner"
              fallback_image={medwiki_static_image}
              className={`object-fit-cover w-100 h-100 `}
              onClick={() => onCardClick(id, title)}
              extraClass="hover-image w-100 h-100 position-relative"
            />
          </Card.Image>
        )}
        {type !== 'small' && navType == 'watch' && image && (
          <Card.Image className="mt-4 cursorPointer">
            <LazyImage
              src={image}
              alt="banner"
              fallback_image={clinical_Video_static_image}
              className={`object-fit-cover w-100 h-100 `}
              onClick={() => onCardClick(id, title)}
            />
            <div className="overlay">
              <div className="position-absolute translate-middle start-50 top-50 playIconAnimation">
                <i className="flaticon-play text-white position-absolute translate-middle start-50 top-50 z-1"></i>
              </div>
            </div>
          </Card.Image>
        )}
        {type !== 'small' && navType == 'cme' && image && (
          <Card.Image className="mt-4 cursorPointer">
            <LazyImage
              src={image}
              alt="banner"
              fallback_image={default_images?.session}
              className={`object-fit-cover w-100 h-100`}
            />
            <div
              className="d-flex align-items-end p-md-4 p-3 z-1 justify-content-between text-white overlay"
              onClick={() => onCardClick(id, title)}
            >
              {startDateTime && (
                <h5 className="fs-3 fw-semibold">
                  {dayjs(startDateTime).format('ddd')} , {dayjs(startDateTime).format('MMM DD, YY')}{' '}
                  - {dayjs(startDateTime).format('h:mm a')}{' '}
                </h5>
              )}
            </div>
            <CpdPoint data={{ cpddetail: cpdDetails }} />
          </Card.Image>
        )}
        {navType !== 'Watch' && (
          <div className="mt-4 d-flex gap-3 flex-wrap">
            <Card.Button className="btn-outline-primary" onClick={cardClick}>
              Attend
            </Card.Button>
            <Card.Button className="btn-primary" onClick={() => setShow(true)}>
              Get Recording
            </Card.Button>
          </div>
        )}
        <Card.Footer>
          <div className="me-auto d-flex align-items-center flex-grow-1">
            {navType != 'cme' && (
              <span className="clr_v3_card__icon  opacity-50  text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center">
                <i className="flaticon-heart-1 me-2 fs-2"></i>
                {<span>{likeCount ?? 0}</span>}
              </span>
            )}
            {navType != 'cme' && (
              <span className="clr_v3_card__icon opacity-50  text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center">
                <i className="flaticon-oval-black-speech-bubble me-2 fs-2"></i>
                {<span>{commentCount ?? 0}</span>}
              </span>
            )}
            {navType != 'cme' && (
              <span className="clr_v3_card__icon text-dark py-1 d-inline-flex align-items-center justify-content-center opacity-50 ">
                <i className="flaticon-eye me-2 fs-2"></i>
                {<span>{viewCount ?? 0}</span>}
              </span>
            )}
            {/* {navType == 'cme' && (
              <span
                title="Participants"
                className="clr_v3_card__icon text-dark py-1 d-inline-flex align-items-center justify-content-center opacity-50 "
              >
                <i class="flaticon-user me-2 fs-2"></i>
                {participantCount && <span>{participantCount}</span>}
              </span>
            )} */}
          </div>

          {sponserLogo && sponserLogo?.length > 0 ? (
            <Swiper
              className="clr_v3_sponsor text-right me-0"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect={'fade'}
            >
              {sponserLogo &&
                sponserLogo?.length > 1 &&
                sponserLogo?.map((_sp, idx) => (
                  <SwiperSlide
                    key={idx + 1}
                    className="clr_v3_sponsor_slide w-100 position-relative"
                  >
                    <LazyImage
                      src={_sp}
                      alt="sponsor"
                      className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                      logo
                    />
                  </SwiperSlide>
                ))}
              {sponserLogo &&
                sponserLogo?.length == 1 &&
                sponserLogo?.map((_sp, idx) => (
                  <div key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                    <LazyImage
                      src={sponserLogo[0]}
                      alt="sponsor"
                      className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                      logo
                    />
                  </div>
                ))}
            </Swiper>
          ) : (
            <div className="clr_v3_sponsor_slide w-100 position-relative"></div>
          )}
        </Card.Footer>
      </Card.Body>
      <GetRecordingModal id={id} show={show} close={modalClose} />
    </Card>
  );
};

FeaturedCard.propTypes = propTypes;
FeaturedCard.defaultProps = defaultProps;
// #endregion

export default memo(FeaturedCard);
